import { FormattedMessage } from 'react-intl'
import { Label, List, Section } from '../../../../../../../Components/shared/Navbar'
import { HomeLinks } from './HomeLinks'
import { AddAHomeLink } from './AddAHomeLink'
import styles from './YourHomeLink.module.scss'

export const YourHomeLink = () => {
  return (
    <Section>
      <Label>
        <FormattedMessage
          id='YourHomeLink.yourHome.label'
          defaultMessage='Your Home'
        />
      </Label>
      <List className={styles.list}>
        <HomeLinks />
        <AddAHomeLink />
      </List>
    </Section>
  )
}
